import React, { useContext } from "react";
import Context from "../OriginStoryProvider";
import Header from "./Header";
import TopText from "./TopText";
import QuoteWithImg from "./QuoteWithImg";
import QuoteWithCentredImg from "./QuoteWithCentredImg";
import DeepDive1 from "./DeepDive1";
import CentredImg1 from "./CentredImg1";
import FullWidthImage from "../Shared/FullWidthImage";
import LargeQuote from "../Shared/LargeQuote";
import SquareImg1 from "./SquareImg1";
import SquareImg2 from "./SquareImg2";
import HeadlineQuote from "../Shared/HeadlineQuote";
import DeepDive2 from "./DeepDive2";
import MediaAndText from "../Shared/MediaAndText";
import ImageCompare from "./ImageCompare";
import ImageWithArrows from "./ImageWithArrows";
import ParagraphsSection from "./ParagraphsSection";
import Stats from "./Stats";
import Video from "./Video";

const Chapter2 = () => {
	const {
		data: { content },
	} = useContext(Context);

	if (!content.chapters) return null;

	return (
		<section id="chapter-2" className="chapter-2">
			<Header />
			<TopText />
			<QuoteWithImg
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-2/railroad.jpg`}
				imgSrcset={`${mainScript.assetPath}images/webp/chapter-2/railroad-400w.webp 400w, 
						${mainScript.assetPath}images/webp/chapter-2/railroad-600w.webp 600w, 
						${mainScript.assetPath}images/webp/chapter-2/railroad-800w.webp 800w, 
						${mainScript.assetPath}images/webp/chapter-2/railroad-1000w.webp 1000w, 
						${mainScript.assetPath}images/webp/chapter-2/railroad-1200w.webp 1200w, 
						${mainScript.assetPath}images/webp/chapter-2/railroad-1600w.webp 1600w, 
						${mainScript.assetPath}images/webp/chapter-2/railroad-2000w.webp 2000w,
						${mainScript.assetPath}images/webp/chapter-2/railroad-2400w.webp 2400w,
						${mainScript.assetPath}images/webp/chapter-2/railroad-2879w.webp 2879w
						`}
				imgSizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 2000px) 2000px, (max-width: 2400px) 2400px, (min-width: 2401px) 2879px"
				quote={content.chapters.second.quote_with_img_1.quote}
				citation={content.chapters.second.quote_with_img_1.attribution}
				imgCaption={content.chapters.second.quote_with_img_1.img_caption}
				imgAlt=""
				elClass="chapter-2__quote-with-img--1"
				paragraph={content.chapters.second.quote_with_img_1.paragraph}
				imgWidth="2880"
				imgHeight="1656"
			/>
			<QuoteWithCentredImg />
			<DeepDive1 />
			<CentredImg1 />
			<FullWidthImage
				elClass="chapter-2__full-width-img--1"
				imgSizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px,  (max-width: 2000px) 2000px, (max-width: 2400px) 2400px, (min-width: 2401px) 2879px"
				imgSrcset={`${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-400w.webp 400w, 
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-600w.webp 600w, 
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-800w.webp 800w,
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-1000w.webp 1000w, 
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-1200w.webp 1200w, 
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-1600w.webp 1600w, 
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-2000w.webp 2000w,
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-2400w.webp 2400w,
					${mainScript.assetPath}images/webp/chapter-2/sumner-hall-1891-2879w.webp 2879w
					`}
				imgCaption={content.chapters.second.full_width_img_1.img_caption}
				imgSrc={`${mainScript.assetPath}images/png/chapter-2/sumner-hall-1891.png`}
				imgAlt={content.chapters.second.full_width_img_1.img_alt}
				imgWidth="2880"
				imgHeight="2040"
			/>
			<LargeQuote
				elClass="chapter-2__purple-quote--1"
				quote={content.chapters.second.purple_quote_1.quote}
				source={content.chapters.second.purple_quote_1.attribution}
				imgSrc={`${mainScript.assetPath}images/svg/graphics/shape-bg--shield.svg`}
			/>
			<SquareImg1 />
			<SquareImg2 />
			{/* Start of "An oasis..." section */}
			<HeadlineQuote
				elClass="chapter-2__headline-quote--2"
				quote={content.chapters.second.headline_quote_2.quote}
				source={content.chapters.second.headline_quote_2.attribution}
			/>
			<ImageWithArrows />
			<DeepDive2 />
			<MediaAndText
				image={`${mainScript.assetPath}images/jpg/chapter-2/review-of-reviews-1893.jpg`}
				imgCaption={content.chapters.second.media_text_1.img_caption}
				imgAlt={content.chapters.second.media_text_1.img_alt}
				paragraph={content.chapters.second.media_text_1.paragraph}
				elClass='chapter-2__media-and-text'
			/>
			<ImageCompare />
			<FullWidthImage
				elClass="chapter-2__full-width-img--2"
				imgCaption={content.chapters.second.full_width_img_2.img_caption}
				imgSrcset={`${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-400w.webp 400w, 
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-600w.webp 600w, 
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-800w.webp 800w, 
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-1000w.webp 1000w, 
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-1200w.webp 1200w, 
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-1600w.webp 1600w, 
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-2000w.webp 2000w,
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-2400w.webp 2400w,
						${mainScript.assetPath}images/webp/chapter-2/santa-fe-depot-claremont-1906-2879w.webp 2879w
						`}
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-2/santa-fe-depot-claremont-1906.jpg`}
				imgSizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (max-width: 1200px) 1200px, (max-width: 1600px) 1600px, (max-width: 2000px) 2000px, (max-width: 2400px) 2400px, (min-width: 2401px) 2879px"
				imgAlt={content.chapters.second.full_width_img_2.img_alt}
				imgHeight="2090"
				imgWidth="2880"
			/>
			<QuoteWithImg
				imgSrcset={`${mainScript.assetPath}images/webp/chapter-2/roosevelt-pearson-hall-400w.webp 400w, 
						${mainScript.assetPath}images/webp/chapter-2/roosevelt-pearson-hall-600w.webp 600w`}
				imgSizes="(max-width: 400px) 400px, (min-width: 401px) 600px"
				imgSrc={`${mainScript.assetPath}images/jpg/chapter-2/roosevelt-pearson-hall.jpg`}
				quote={content.chapters.second.quote_with_img_3.quote}
				citation={content.chapters.second.quote_with_img_3.attribution}
				imgCaption={content.chapters.second.quote_with_img_3.img_caption}
				imgAlt=""
				elClass="chapter-2__quote-with-img--3"
				imgWidth="648"
				imgHeight="451"
			/>
			<ParagraphsSection />
			<Stats />
			<LargeQuote
				elClass="chapter-2__purple-quote--2"
				quote={content.chapters.second.purple_quote_2.quote}
				source={content.chapters.second.purple_quote_2.attribution}
			/>
			<Video
				videoUrl="https://player.vimeo.com/video/1044468047?badge=0&autopause=0&player_id=0&app_id=58479"
				imgUrl={`${mainScript.assetPath}images/png/chapter-2/temp-thumbnail.png`}
				elClass="chapter-2__video"
				text={content.chapters.second.video.paragraph}
			/>
		</section>
	);
};

export default Chapter2;
